import { Heading } from "monday-ui-react-core";

import emptyStateImg from "@/assets/icons/search-empty-state.svg";
import { FullHeight } from "@/components/Common";

export function EmptyCommandList() {
  return (
    <FullHeight>
      <img
        style={{
          width: "290px",
          height: "250px",
        }}
        src={emptyStateImg}
        alt=""
      />
      <Heading type={Heading.types.h2} value="No saved CLI command yet" />
      <span
        style={{
          width: "50%",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Save your first command by clicking the save button on the CLI - Automate Actions panel.
      </span>
    </FullHeight>
  );
}
